import { Stack, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import TextEditor from 'src/components/editor';

export default function Editor({ value, setValue }) {
  return (
    <Stack
      py="20px"
      px="16px"
      spacing="12px"
      height="510px"
      width="50%"
      borderRadius="6px"
      border={theme => `1px solid ${theme.palette.border.primaryBlack3}`}
    >
      <Typography variant="subheading1" fontSize={16}>
        Type Post Content
      </Typography>
      <Stack spacing="8px">
        <TextField
          multiline
          fullWidth
          rows={28}
          maxRows={28}
          value={value}
          onChange={e => setValue(e.target.value)}
        />
      </Stack>
    </Stack>
  );
}

Editor.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
};
